<template>
  <v-container>
    <v-row>
      <v-col md="6" xs="12" class="nice-data-col" :style="'color:' + textColor">
        <h3 v-for="(item, index) in Object.keys(values)" v-bind:key="index">
          {{ $t(langPrefix + item) }}:
        </h3>
      </v-col>

      <v-col md="6" xs="12" class="nice-data-col">
        <h4 v-for="(item, index) in values" v-bind:key="index">
          {{ item }}
        </h4>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NiceData",
  props: ["langPrefix", "data", "textColor", "ignore"],

  computed: {
    values() {
      if (!this.ignore) return this.data;

      let values = {};

      for (const [key, value] of Object.entries(this.data)) {
        if (!this.ignore.includes(key)) values[key] = value;
      }

      return values;
    },
  },
};
</script>

<style>
.nice-data-col {
  text-align: left;
}

.nice-data-col > h4 {
  max-height: 35px;
  height: 35px;
}
.nice-data-col > h3 {
  max-height: 35px;
  height: 35px;
}
</style>
